import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { AppErrorResponse, applyFieldErrors } from '../services/axios';
import { UseFormSetError, FieldValues } from 'react-hook-form';

export interface MutationParams<
  T = unknown,
  TFormValues extends FieldValues = any,
> {
  onSuccess?: (data?: T) => void;
  onError?: (error?: AppErrorResponse) => void;
  setError?: UseFormSetError<TFormValues>;
}

export function useAppMutation<
  TData = unknown,
  TVariables = void,
  TFormValues extends FieldValues = any,
>(
  options: UseMutationOptions<TData, AppErrorResponse, TVariables> & {
    setError?: UseFormSetError<TFormValues>;
  },
): UseMutationResult<TData, AppErrorResponse, TVariables> {
  const { setError, ...restOptions } = options;

  return useMutation({
    retry: false,
    ...restOptions,
    onError: (error, variables, context) => {
      if (setError) {
        applyFieldErrors(error, setError);
      }

      restOptions.onError?.(error, variables, context);
    },
  });
}
